/**
 * Lightweight logger that is a no-op in production builds.
 *
 * Use `logError` in catch handlers instead of raw `console.error` so that
 * error details stay visible during development while remaining silent
 * (no information leakage) in production bundles served to end users.
 */

// CRA/Vite both expose NODE_ENV via process.env.
// In production it is set to 'production' at build time.
const IS_DEV =
  typeof process !== 'undefined' &&
  process?.env?.NODE_ENV !== 'production';

export function logError(...args) {
  if (IS_DEV && typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}

export function logWarn(...args) {
  if (IS_DEV && typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}
